import {HttpClient,HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {SERVER_API_URL} from 'src/app/app.constants';
import {createRequestOption} from 'src/app/shared/util/request-util';
import {IDelegation} from './../../shared/model/delegation.model';


type EntityResponseType = HttpResponse<IDelegation>;
type EntityArrayResponseType = HttpResponse<IDelegation[]>;

@Injectable({ providedIn: 'root' })
export class DelegationMySuffixService {
    
    private resourceUrl = SERVER_API_URL + 'api/delegations';

    constructor(private http: HttpClient) {}

    create(delegation: IDelegation): Observable<EntityResponseType> {
        return this.http.post<IDelegation>(this.resourceUrl+'/save', delegation, { observe: 'response' });
    }

    update(delegation: IDelegation): Observable<EntityResponseType> {
        return this.http.put<IDelegation>(this.resourceUrl+'/update', delegation, { observe: 'response' });
    }

    find(id: number): Observable<EntityResponseType> {
        return this.http.get<IDelegation>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }

    view(id: number): Observable<EntityResponseType> {
        return this.http.get<IDelegation>(`${this.resourceUrl}/view/${id}`, { observe: 'response' });
    }

    query(req?: any,underwriterInsurerId?:any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http.get<IDelegation[]>(this.resourceUrl+'/by-underwriter/'+underwriterInsurerId, { params: options, observe: 'response' });
    }


    delete(id: number): Observable<HttpResponse<any>> {
        return this.http.delete<any>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }
    searchQuery(searchKey?: string, url?: string, id?: any, req?: any): Observable<HttpResponse<any[]>> {
        console.log('inside search', id);

        // const options = createRequestOption(req);
        searchKey = searchKey.trim().replace('+', '');
        return this.http.get<any[]>(this.resourceUrl + url + '?searchKey=' + searchKey, { params: { id: id }, observe: 'response' });
    }

    findByIdAndFromEffectiveDate(id: number, fromEffectiveDate: string): Observable<EntityResponseType> {
        return this.http.get<IDelegation>(`${this.resourceUrl}/${id}/${fromEffectiveDate}`, { observe: 'response' });
    }

    checkForDelegations(id: any): Observable<any> {
        return this.http.get<any>(`${this.resourceUrl}/check-for-delegations-in-policies/${id}`, { observe: 'response' });
    }
    
    changeDelegationStatus(id: any): Observable<any> {
        return this.http.delete<any>(`${this.resourceUrl}/change-status/${id}`, { observe: 'response' });
    }

    createAsDraft(delegation: IDelegation): Observable<EntityResponseType> {
        return this.http.post<IDelegation>(this.resourceUrl+'/save-as-draft', delegation, { observe: 'response' });
    }

    getAllActiveDelegationsForPolicy(incDate,expDate): Observable<HttpResponse<any>> {
        let obj={
            inceptionDate: incDate,
            expiryDate: expDate
        }
        return this.http.post<any>(`${this.resourceUrl}/get-all-active-delegations`,obj, { observe: 'response' });
    }

    
    checkForUnderwriterInsurerInDelegations(id: any): Observable<any> {
        return this.http.get<any>(`${this.resourceUrl}/check-for-underwriter-insurer-in-delegations/${id}`, { observe: 'response' });
    }
    
    checkForInsurerInDelegations(id: any): Observable<any> {
        return this.http.get<any>(`${this.resourceUrl}/check-for-insurer-in-delegations/${id}`, { observe: 'response' });
    }

    deleteDelegation(id: any): Observable<any> {
        return this.http.delete<any>(`${this.resourceUrl}/delete-delegation/${id}`, { observe: 'response' });
    }

}
